import { Component, Input, OnInit } from "@angular/core";
import localeCO from "@angular/common/locales/es-CO";

import { ModalController, NavParams } from "@ionic/angular";

import { File } from "@ionic-native/file/ngx";
import { NavController, Platform } from "@ionic/angular";
import { HttpClient } from "@angular/common/http";
import { FileOpener } from "@ionic-native/file-opener/ngx";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

/*import { registerLocaleData } from "@angular/common";
registerLocaleData(localeCO, "co");
import { CurrencyPipe } from "@angular/common";*/

@Component({
  selector: "app-efectivorespuesta",
  templateUrl: "./efectivorespuesta.page.html",
  styleUrls: ["./efectivorespuesta.page.scss"],
})
export class EfectivorespuestaPage implements OnInit {
  @Input() data: any;
  entidadrecaudo: string;
  pdfObj = null;
  monto: number;
  descripcion;
  datos: any;
  constructor(
    //private currencyPipe: CurrencyPipe,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    private http: HttpClient,
    private fileOpener: FileOpener,
    private plt: Platform,
    private file: File
  ) {
    this.datos = this.navParams.get("data");
    console.log("DATA:");
    console.log(this.datos);
    this.entidadrecaudo = this.navParams.get("entidadrecaudo");
    console.log("entidadRecaudo: " + this.entidadrecaudo);
    this.monto = 0;
  }
  logoData: any = [];
  imgLogo = null;
  joinDate: string;

  ngOnInit() {
    let myDate = new Date();
    this.joinDate =
      myDate.getDate() +
      "/" +
      (myDate.getMonth() + 1) +
      "/" +
      myDate.getFullYear();
    //console.log(this.joinDate);
    /*this.loadLocalAssetToBase64("./assets/1.png");
    this.loadLocalAssetToBase64(
      "./assets/imagenes/sistema/epayco/epayco_logo.png"
    );
    this.loadLocalAssetToBase64(
      "./assets/imagenes/sistema/epayco/" + this.entidadrecaudo + ".png"
    );*/
    let assests = [
      "./assets/1.png",
      "./assets/imagenes/sistema/epayco/epayco_logo.png",
      "./assets/imagenes/sistema/epayco/" + this.entidadrecaudo + ".png",
    ];
    this.loadAllAssetsBase64(assests);

    this.timeout(6000 * 3 * 10).then((_) => this.dismiss());
  }
  ionViewDidEnter() {
    this.makePdf();
  }
  timeout(ms) {
    //pass a time in milliseconds to this function
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  dismiss() {
    this.modalCtrl.dismiss({
      dismissed: true,
    });
  }

  async loadAllAssetsBase64(assets: string[]) {
    let path;
    const promises = [];
    for (let i = 0; i < assets.length; i++) {
      path = assets[i];
      promises.push(this.loadLocalAssetToBase64(path));
    }
    await Promise.all(promises);
  }

  loadLocalAssetToBase64(path) {
    this.http.get(path, { responseType: "blob" }).subscribe((res) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        let imgBase64 = reader.result;
        this.logoData.push(imgBase64);
      };
      reader.readAsDataURL(res);
    });
  }

  makePdf() {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    var docDefinition = {
      content: [
        {
          text: this.joinDate,
          fontSize: 8,
          alignment: "left",
          margin: [0, 0, 0, 28],
        },
        {
          text: "Pasarela de pagos | ePyco",
          fontSize: 8,
          alignment: "center",
          margin: [0, -38, 0, 28],
        },
        {
          columns: [
            [
              {
                image: this.logoData[0],
              },
              {
                text: "¿PREGUNTAS AL COMERCIO?",
                style: "sub_header_default",
              },

              {
                style: "tableExample",
                table: {
                  headerRows: 1,
                  body: [
                    [
                      { text: "Llámenos", bold: true },
                      { text: "3011234567", alignment: "right" },
                    ],
                    [
                      { text: "Escríbanos", bold: true },
                      { text: "cronoleo@gmail.com", alignment: "right" },
                    ],
                    ["", ""],
                    ["", ""],
                    ["", ""],
                    ["", ""],
                    ["www.cronoleo.com", ""],
                  ],
                },
                layout: "noBorders",
              },
            ],

            [
              {
                image: this.logoData[1],
                width: 100,
                style: "imgRight",
              },
              {
                image: this.logoData[2],
                width: 50,
                style: "imgRight",
              },
              {
                text: [
                  "Teniendo en cuenta la fecha de pago, acércate al punto ",
                  { text: this.datos.data.banco, bold: true },
                  " más cercano e indica los siguientes datos:",
                ],
                fontSize: 12,
                margin: [0, 20, 0, 8],
              },
              {
                style: "tableExample",
                table: {
                  widths: ["*", "*"],
                  headerRows: 1,
                  body: [
                    [
                      { text: "PIN", style: "tableHeader" },
                      { text: "Código del convenio", style: "tableHeader" },
                    ],
                    [
                      {
                        alignment: "left",
                        fontSize: 20,
                        text: this.datos.data.pin,
                      },
                      {
                        alignment: "right",
                        fontSize: 20,
                        text: this.datos.data.codigoproyecto,
                      },
                    ],
                  ],
                },
                layout: "headerLineOnly",
              },
            ],
          ],
        },
        {
          style: "tableExample",
          table: {
            widths: ["*", "*"],
            body: [
              ["Total a pagar", "Pague en efectivo antes de"],
              [
                {
                  text: this.datos.data.valor_pesos,
                  italics: true,
                  color: "gray",
                },
                {
                  text: this.datos.data.fechaexpiracion,
                  italics: true,
                  color: "gray",
                },
              ],
            ],
          },
        },
        {
          text: [
            {
              text: "Recaudo a nombre de Payco ",
              bold: true,
              fontSize: 18,
              alignment: "center",
            },
            { text: "Payco, paga y cobra online S.A.S.", fontSize: 18 },
          ],
        },
      ],
      styles: {
        imgRight: {
          alignment: "right",
        },
        header: {
          bold: true,
          fontSize: 20,
          alignment: "right",
        },
        sub_header: {
          fontSize: 18,
          alignment: "right",
        },
        sub_header_default: {
          fontSize: 17,
          alignment: "left",
          margin: [0, 20, 0, 17],
        },
        subheader: {
          fontSize: 17,
          alignment: "center",
          margin: [0, 20, 0, 15],
        },
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: "black",
        },
      },
      pageSize: "A4",
      pageOrientation: "portrait",
    };
    this.pdfObj = pdfMake.createPdf(docDefinition);
  }

  downloadPdf2() {
    this.pdfObj.open();
    this.pdfObj.download("recibo_" + this.datos.data.banco);
  }

  downloadPdf() {
    if (this.plt.is("cordova")) {
      this.pdfObj.getBuffer((buffer) => {
        var blob = new Blob([buffer], { type: "application/pdf" });
        let name = "recibo_" + this.datos.data.banco + ".pdf";
        // Guarde el PDF en el directorio de datos de nuestra aplicación
        this.file
          .writeFile(this.file.dataDirectory, name, blob, { replace: true })
          .then((fileEntry) => {
            // Abra el PDf con las herramientas del sistema operativo correctas
            this.fileOpener.open(
              this.file.dataDirectory + name,
              "application/pdf"
            );
          });
      });
    } else {
      // On a browser simply use download!
      this.pdfObj.download("recibo_" + this.datos.data.banco + ".pdf");
      this.pdfObj.open();
    }
  }
}
